module.exports =
  product_reviews: require '../product_reviews/main.html.mustache'
